import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminAttendance() {
  const [records, setRecords] = useState([]);
  const [date, setDate]       = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(true);

  const load = (d) => {
    setLoading(true);
    axios.get('/admin/attendance', { params:{ date: d } })
      .then(r => setRecords(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(date); }, [date]);

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Attendance log</h1><p className="page-sub">{records.length} check-ins on selected date</p></div>
        <input type="date" className="input" style={{ width:180 }} value={date} onChange={e => setDate(e.target.value)} />
      </div>

      <div className="card">
        {loading ? <div className="loading-wrap"><div className="spinner"></div></div> : (
          <table className="table">
            <thead><tr><th>Member</th><th>Check-in</th><th>Method</th></tr></thead>
            <tbody>
              {records.length === 0 && <tr><td colSpan={3} style={{ textAlign:'center', color:'var(--text-muted)', padding:32 }}>No attendance on this date.</td></tr>}
              {records.map(r => (
                <tr key={r.id}>
                  <td>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <div className="avatar" style={{ width:30, height:30, fontSize:11 }}>
                        {r.photo ? <img src={r.photo} alt="" /> : r.name?.slice(0,2).toUpperCase()}
                      </div>
                      <span className="name">{r.name}</span>
                    </div>
                  </td>
                  <td>{r.check_in ? new Date(r.check_in).toLocaleTimeString('en-GB', { hour:'2-digit', minute:'2-digit' }) : '—'}</td>
                  <td><span className={`badge ${r.marked_by==='qr'?'badge-accent':'badge-muted'}`}>{r.marked_by}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
